var inspiration_book = (function() {

    // Template for each inspiration book item in menu
    function constructItem(item) {
        // Construct Item html
        var inspiration_book_item_layout = "";
        inspiration_book_item_layout += "<div id='operator-" + item.operator_id + "' class='col-md-3 book-item'>";
        inspiration_book_item_layout += "<div class='image' style='background-image: url(" + item.operator_thumb + ");'>";
        inspiration_book_item_layout += "<a href='" + item.operator_url + "' class='btn'>More Information</a>";
        inspiration_book_item_layout += "<button type='button' role='button' data-target=" + item.operator_id + " class='btn removeFromBook'>Remove</button>";
        inspiration_book_item_layout += "</div>";
        inspiration_book_item_layout += "<h3 class='h6'><a href='" + item.operator_url + "'>" + item.operator_name + "</a></h3>";
        inspiration_book_item_layout += "</div>";
        // Return the constructed HTML
        return inspiration_book_item_layout;
    }

    // Function to Build the menu
    function buildInspirationBook(book_items) {
        if(book_items.length == 0 || book_items == null || book_items == undefined) {
            $(".inspiration-book-buttons").hide().before("<div class='empty-message'>You haven't added any items to your inspiration book</div><br />");
            $("#inspiration-book-button span").text("0");
        }
        // Loop through items and append to menu
        for(var e = 0; e < book_items.length; e++ ) {
            var builtItem = constructItem(book_items[e]);
            $(".inspiration-book-items").append(builtItem);
        }
        // Build counter on load
        $("#inspiration-book-button span").text(book_items.length);
    }
    // Build map buttons
    function buildInspirationBookButtons(book_items) {
        var mapUrl = $("#viewOperatorsOnMap").attr("href");
        // If this function executes add "?operators" query param
        mapUrl += "?operators="
        // Loop through operators and add their ID to the url
        if(book_items !== null) {
            for(var b = 0; b < book_items.length; b++ ) {
                mapUrl += book_items[b].operator_id;
                // If is not last item add a comma
                if(b !== (book_items.length - 1)) {
                    mapUrl += ",";
                }
            }
        }
        // Change href of button link to new url
        $("#viewOperatorsOnMap").attr("href", mapUrl);
    }

    // Incredment/Decrement counter
    function inspirationBookCounter(direction) {
        // Get current total and convert to int
        var currentVal = parseInt($("#inspiration-book-button span").text());
        // If "up" (increment)
        if(direction == "up") {
            $("#inspiration-book-button span").text(currentVal + 1);
        // Else decrement
        } else {
            $("#inspiration-book-button span").text(currentVal - 1);
        }
    }
    // Construct Print Item
    function constructPrintItem(item) {
        // Construct Item html
        var inspiration_book_item_layout = "";
        inspiration_book_item_layout += "<divid='operator-" + item.operator_id + "' class='row mb-3'>";
        inspiration_book_item_layout += "<div class='col-3'>";
        inspiration_book_item_layout += "<img class='img-fluid' src='" + item.operator_thumb + "'>";
        inspiration_book_item_layout += "</div>";
        inspiration_book_item_layout += "<div class='col-8'>";
        inspiration_book_item_layout += "<h3 class='h6'><a href='" + item.operator_url + "'>" + item.operator_name + "</a></h3>";
        inspiration_book_item_layout += "<address>" + item.operator_address + "</address>";
        inspiration_book_item_layout += "<address>" + item.operator_phone + "</address>";
        inspiration_book_item_layout += "</div>";
        inspiration_book_item_layout += "</div>";
        // Return the constructed HTML
        return inspiration_book_item_layout;
    }
    // Function to Build the page
    function buildInspirationPrintBook(book_items) {
        // Loop through items and append to page
        if(book_items !== null) {
            for(var e = 0; e < book_items.length; e++ ) {
                var builtItem = constructPrintItem(book_items[e]);
                $(".inspiration-items-for-print").append(builtItem);
            }
        }
    }
    // Add item to book
    $(".addToBook").on("click", function() {
        $(".empty-message").hide();
        $(".inspiration-book-buttons").show()
        clearTimeout(resetNotifications);
        // Field variables
        var id = $(this).data("operator-id");
        var name = $(this).data("operator-name");
        var url = $(this).data("operator-url");
        var thumb = $(this).data("operator-thumb");
        var address = $(this).data("operator-address");
        var phone = $(this).data("phone");
        // Build json array
        var item = {
            "operator_id" : id,
            "operator_name" : name,
            "operator_url" : url,
            "operator_thumb" : thumb,
            "operator_address" : address,
            "operator_phone" : phone
        }
        // If local storage object doesn't exist, create an empty object
        if (!localStorage.getItem("inspiration_book_items")) {
            localStorage.setItem("inspiration_book_items", "[]");
        }
        // Convert inspiration book items object into json
        var allInspirationItems = JSON.parse(localStorage.getItem("inspiration_book_items"));
        var itemExists = false;

        // Loop through inspiration items
        for(var i = 0; i < allInspirationItems.length; i++) {
            if(allInspirationItems[i].operator_id == item.operator_id) {
                itemExists = true;
                break;
            }
        }
        // If item doesn't exist
        if(!itemExists) {
            // Push item into json object
            allInspirationItems.push(item);
            // Convert into json string and push into local storage
            localStorage.setItem("inspiration_book_items", JSON.stringify(allInspirationItems));
            // Add new item to map button
            var mapUrl = $("#viewOperatorsOnMap").attr("href");
            mapUrl += "," + item.operator_id
            $("#viewOperatorsOnMap").attr("href", mapUrl);
            // Build new item HTML and add to megamenu
            var newAddition = constructItem(item);
            $(".inspiration-book-items").append(newAddition);
            // Add success message
            $(".inspiration-alert").removeClass("warning").addClass("success").text("You've successfully added " + item.operator_name + " to your inspiration book")
            // Add success class to new menu item
            $("#operator-" + item.operator_id).removeClass("attention").addClass("success");
            // After 5 seconds remove success message
            var resetNotifications = setTimeout(function() {
                $(".inspiration-alert").removeClass("warning").removeClass("success").text("")
                $("#operator-" + item.operator_id).removeClass("attention").removeClass("success");
            }, 5000)
            // Increment counter
            inspirationBookCounter("up");
        // If item does exist
        } else {
            // Add warning message that you've already added item
            $(".inspiration-alert").removeClass("success").addClass("warning").text("You've already added " + item.operator_name + " to your inspiration book")
            $("#operator-" + item.operator_id).removeClass("success").addClass("attention");
            // Remove warning after 5 seconds
            var resetNotifications = setTimeout(function() {
                $(".inspiration-alert").removeClass("warning").removeClass("success").text("")
                $("#operator-" + item.operator_id).removeClass("attention").removeClass("success");
            }, 5000)
        }
        // Open megamenu
        $("#inspiration-book-megamenu").addClass("open");
        $("#inspiration-book-button").parent().addClass("active")
    })

    // Remove from inspiration book
    // Click event on generated DOM items
    $(document).on("click", ".removeFromBook", function() {
        // All items
        var allInspirationItems = JSON.parse(localStorage.getItem("inspiration_book_items"));
        // Target to remove
        var target = $(this).data("target");
        // Loop through items
        for(var n = 0; n < allInspirationItems.length; n++) {
            // If item exists, remove from json object
            if(allInspirationItems[n].operator_id == target) {
                allInspirationItems.splice(n, 1);
                // Remove from dom
                $(this).parent().parent().fadeOut(100).delay(100).remove();
            }
        }
        // Decrement counter
        inspirationBookCounter("down");
        // Remove operator id from URL of map button
        var mapUrl = $("#viewOperatorsOnMap").attr("href");
        mapUrl = mapUrl.replace("," + target, "");
        $("#viewOperatorsOnMap").attr("href", mapUrl);
        // Update local storage
        localStorage.setItem('inspiration_book_items', JSON.stringify(allInspirationItems));
    })

    // Initiate inpsiration book
    // If it doesn't exist, display empty message
    if (!localStorage.getItem("inspiration_book_items")) {
        $(".inspiration-book-buttons").hide().before("<div class='empty-message'>You haven't added any items to your inspiration book</div><br />");
        $("#inspiration-book-button span").text("0");
        buildInspirationBookButtons(JSON.parse(localStorage.getItem("inspiration_book_items")));
        buildInspirationPrintBook(JSON.parse(localStorage.getItem("inspiration_book_items")))
    } else {
        // Else execute build book function
        $(".inspiration-empty").text("");
        buildInspirationBook(JSON.parse(localStorage.getItem("inspiration_book_items")));
        buildInspirationBookButtons(JSON.parse(localStorage.getItem("inspiration_book_items")));
        buildInspirationPrintBook(JSON.parse(localStorage.getItem("inspiration_book_items")))
    }

    // Email inspiration book
    $("#sendToEmail").on("click", function() {
        var book_items = JSON.parse(localStorage.getItem("inspiration_book_items"))
        var url = "mailto:";
        $(".no-email").remove();
        if($("#emailAddress").val() == "" || $("#sendToEmail").val() == undefined) {
            $("#emailAddress").addClass("danger").before("<div class='text-red no-email'>You must enter an email address</div>")
        } else {
            $("#emailAddress").removeClass("danger");
            $(".no-email").hide();
            url += $("#emailAddress").val();
            url += "?subject=Inspiration book from " + $("#emailAddress").val() + "&body="
            for(var e = 0; e < book_items.length; e++ ) {
                url += book_items[e].operator_name + "%0D%0A";
                url += book_items[e].operator_address + "%0D%0A";
                url += book_items[e].operator_phone + "%0D%0A %0D%0A";
            }
            window.location.href = url;
        }
    });
    $("#openPrint").on("click", function() {
        window.print();
    })

})();
